<template>
    <div class="row mb-4">
        <div class="col p-0 px-sm-3">
            <VueSlickCarousel
                class="header-slider"
                :dots="true"
                :arrows="false"
                :infinite="true"
                :autoplay="true"
                :speed="500"
                :fade="true"
                :cssEase="'linear'"
            >
                <div v-for="post in posts" :key="post.id">
                    <div
                        class="header-slider-img"
                        :style="{
                            'background-image': 'url(' + post.coverImage + ')',
                            'background-position': post.coverImageAlignment,
                            'background-size': post.coverImageSizing,
                        }"
                    >
                        <div
                            class="row align-items-center justify-content-center justify-content-sm-start h-100"
                        >
                            <!-- <div class="header-slider-overlay"></div> -->
                            <div
                                class="col-10 col-sm-6 bg-text-header z-index-2 mt-auto p-3 p-md-4 mb-5 ms-sm-4"
                            >
                                <p class="mb-0">
                                    {{ formatDate(post.published_at) }}
                                </p>
                                <h1 class="fw-600">
                                    {{ post.title }}
                                </h1>
                                <p class="text-justify">
                                    {{ post.summary }}
                                </p>
                                <router-link
                                    :to="{name: 'post', params: { slug: post.slug }}"
                                    class="btn btn-renault-dark d-none d-sm-inline-block"
                                >
                                    leer más
                                </router-link>

                                <div
                                    class="d-flex align-items-center d-sm-none"
                                >
                                    <router-link
                                        :to="{name: 'post', params: { slug: post.slug }}"
                                        class="btn p-0"
                                    >
                                        leer más
                                    </router-link>
                                    <span class="ms-2" aria-hidden="true"
                                        ><i
                                            class="fa-solid fa-chevron-right amarillo-renault"
                                        ></i
                                    ></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </VueSlickCarousel>
        </div>
    </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
    props: {
        posts: Array,
    },
    components: { VueSlickCarousel },
    mounted() {},
    methods: {
        formatDate(date) {
            const options = { year: "numeric", month: "long", day: "numeric" };
            return new Date(date).toLocaleDateString("es", options);
        },
    },
};
</script>
